// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasFaceMeh: CreateIconOptions = {
  "displayName": "FASFaceMeh",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
};
